import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { CONTACT } from "./constants/contact";

// Main Pages
import Home from "./pages/Home";
import NotFoundPage from "./pages/NotFoundPage";
import ChapaYPinturaServicePage from "./pages/ChapaYPinturaServicePage";
import MecanicaServicePage from "./pages/MecanicaServicePage";
import MantenimientoServicePage from "./pages/MantenimientoServicePage";
import AlquilerServicePage from "./pages/AlquilerServicePage";
import NosotrosPage from "./pages/NosotrosPage";

import ServiceDetailsPage from "./pages/ServiceDetailsPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Terms from "./components/Terms";
import CookiesPolicy from "./components/CookiesPolicy";
import Redirect from "./components/Redirect";

// Public Pages
import UnsubscribePage from "./pages/UnsubscribePage";

// WhatsApp Redirect Component
const WhatsAppRedirect = () => {
  useEffect(() => {
    window.location.href = CONTACT.whatsapp.link;
  }, []);
  return null;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* Nosotros */}
        <Route path="/nosotros" element={<NosotrosPage />} />

        {/* SEO old URL */}
        <Route path="/whatsapp" element={<WhatsAppRedirect />} />
        <Route path="/mairena-del-aljarafe" element={<Home />} />
        <Route path="/siniestros" element={<Home />} />
        <Route path="/asegurado-franquicia" element={<Home />} />
        <Route path="/taller-poligono-pisa" element={<Redirect to="/mecanica" />} />
        <Route path="/contacto" element={<WhatsAppRedirect />} />
        <Route path="/blog" element={<Home />} />
        <Route path="/lunas" element={<Redirect to="/mantenimiento" />} />
        <Route path="/servicios" element={<Redirect to="/chapa-y-pintura" />} />
        <Route path="/reparacion-llantas" element={<Redirect to="/chapa-y-pintura" />} />
        <Route path="/pulido-de-faros" element={<Redirect to="/mantenimiento" />} />
        <Route path="/revisiones" element={<Home />} />
        <Route path="/ofertas" element={<Home />} />

        {/* Terms and Legal */}
        <Route path="/terminos" element={<Terms />} />
        <Route path="/cookies" element={<CookiesPolicy />} />
        <Route path="/privacidad" element={<PrivacyPolicy />} />

        {/* CHAPA Y PINTURA */}
        <Route path="/chapa-y-pintura" element={<ChapaYPinturaServicePage />} />
        {/* MECÁNICA */}
        <Route path="/mecanica" element={<MecanicaServicePage />} />
        {/* MANTENIMIENTO */}
        <Route path="/mantenimiento" element={<MantenimientoServicePage />} />
        {/* ALQUILER */}
        <Route path="/alquiler" element={<AlquilerServicePage />} />

        {/* RESERVAR CITA - Redirect to WhatsApp */}
        <Route path="/reservar" element={<WhatsAppRedirect />} />
        <Route path="/reservar-cita" element={<WhatsAppRedirect />} />
        <Route path="/reserva" element={<WhatsAppRedirect />} />
        <Route path="/cita" element={<WhatsAppRedirect />} />

        {/* Customer Portal - Redirect to WhatsApp */}
        <Route path="/mi-reserva" element={<WhatsAppRedirect />} />
        <Route path="/estado-reserva" element={<WhatsAppRedirect />} />

        {/*
          Single param route.
          Example URLs:
          /chapa-y-pintura/reparacion-siniestros
          /mecanica/embrague-distribucion
          /mantenimiento/cargaac
          /alquiler/seat-ateca-2020
        */}
        <Route path="/:category/:slug" element={<ServiceDetailsPage />} />

        {/* Email Unsubscribe */}
        <Route path="/cancelar-suscripcion" element={<UnsubscribePage />} />

        {/* Admin Portal - Redirect to WhatsApp */}
        <Route path="/admin" element={<WhatsAppRedirect />} />
        <Route path="/admin/*" element={<WhatsAppRedirect />} />

        {/* Catch-all (optional) */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
